import { useState } from 'react';
import { Pagination } from '@myme/utils';

const defaultInitialPagination: Pagination = {
  page: 0,
  pageSize: 5
};

export const usePagination = (initialPagination: Partial<Pagination> = defaultInitialPagination) => {
  const [pagination, setPagination] = useState({
    ...defaultInitialPagination,
    ...initialPagination
  });

  const isFirstPage = pagination.page === 0;
  const isLastPage = (total: number) => (pagination.page + 1) * pagination.pageSize >= total;
  const getLastPageNumber = (total: number) => Math.ceil(total / pagination.pageSize);

  const handleChangePage = (page: number) => setPagination(prevState => ({ ...prevState, page }));

  const handleChangePageSize = (pageSize: number) => setPagination(prevState => ({ ...prevState, pageSize }));

  return {
    pagination,
    isFirstPage,
    isLastPage,
    getLastPageNumber,
    handleChangePage,
    handleChangePageSize,
    setPagination
  };
};

export const getPageValueForPaginationStartingFromOne = (page: number) => {
  if (!page) {
    return 0;
  }

  return page - 1;
};
